/**
 * Sentinel symbol used to mark an HTTP error response as "already surfaced
 * by the global server error interceptor". Component-level catch handlers
 * read it via `isErrorHandledByInterceptor` and skip showing their own
 * snackbar — preventing the double-blink UX where the interceptor toast is
 * immediately replaced by an identical (or worse: generic) component toast.
 *
 * Lives in `libs/core/utils` (not next to the interceptor) so the
 * `NotificationService` can read the flag without pulling in the interceptor
 * module — which would create a circular dependency
 * (`notification.service.ts` → `server-error.interceptor.ts` → back to
 * `notification.service.ts`).
 */
const HANDLED_SYMBOL = Symbol('orion.serverErrorInterceptor.handled');

export const markErrorAsHandledByInterceptor = (error: unknown): void => {
  if (error !== null && typeof error === 'object') {
    (error as Record<symbol, boolean>)[HANDLED_SYMBOL] = true;
  }
};

export const isErrorHandledByInterceptor = (err: unknown): boolean =>
  err !== null &&
  typeof err === 'object' &&
  (err as Record<symbol, boolean>)[HANDLED_SYMBOL] === true;
